/**
 * Message Utilities
 *
 * Helper functions for message processing and manipulation
 */

import type { T_ChatMessageV2 } from "../types";
import { stripChatApprovalInterruptMessage } from "@lattice/core-lib/types/chat";

/**
 * Get message content for rendering
 *
 * V2: Simplified structure - just return the message string
 * Returns streaming content if available, otherwise regular content
 */
export const getMessageContent = (message: T_ChatMessageV2): string => {
  let content = message.message;

  // For streaming assistant messages, show accumulated streaming content
  if (
    message.role === "assistant" &&
    message.isStreaming &&
    message.streamingContent !== undefined
  ) {
    content = message.streamingContent;
  }

  if (message.role === "assistant") {
    content = stripChatApprovalInterruptMessage(content);
  }

  return fixCodeFences(content);
};

/**
 * Ensure fenced code blocks (```) start on their own line.
 * Models sometimes emit ```lang immediately after text on the same line,
 * which CommonMark treats as inline code spans instead of a code fence.
 */
function fixCodeFences(content: string): string {
  return content.replace(/([^\n])```/g, "$1\n```");
}
